import { useEffect } from 'react'

// Utils & constants
import { redirect404 } from 'lib/utils/redirect-404'
import { revalidate } from 'lib/constants/revalidate'

// Services.
import eventService from '../../lib/services/pixels-headless/events'

// Components.
import Layout from '../../components/Layout/Layout'
import BackToSearch from '../../components/BackToSearch'
import EventHero from '../../components/Section/EventHero'
import EventNavigation from '../../components/EventNavigation'
import EventContent from '../../components/EventContent'
import FaqAndCTA from '../../components/Section/FaqAndCTA'
import ProviderEvents from '../../components/Section/ProviderEvents'
import RelatedEvents from '../../components/Section/RelatedEvents'
import StickyActionBar from '../../components/Section/StickyActionBar'

/**
 * Get list of Events from CMS.
 */
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

/**
 * Get data for current Event by url slug.
 */
export async function getStaticProps({ params, preview = false }) {
  let post
  try {
    post = await eventService.getEventPage(params.event, preview)
  } catch (err) {
    console.warn(
      `[tapahtuma] Failed to fetch event "${params.event}": ${err.message}`,
    )
    return redirect404()
  }

  if (post.length === 0) {
    return redirect404()
  }

  return {
    props: {
      post,
      preview,
    },
    revalidate,
  }
}

export default function Event({ post, preview }) {
  // Append body class.
  useEffect(() => {
    document.querySelector('body').classList.add('event-page')
  }, [])

  const hasReviews =
    post.fields.reviews !== false &&
    post.fields.reviews !== undefined &&
    post.fields.reviews.length !== 0

  return (
    <Layout data={post} preview={preview}>
      <EventHero images={post.fields.image_gallery} />
      <StickyActionBar section={{ price: post.fields.price }} />
      <EventNavigation
        general={true}
        prices={post.fields.pricing !== false}
        additionalServices={post.fields.additional_services !== false}
        reviews={hasReviews}
        faq={post.fields.faq !== false}
        price={post.fields.price}
        guests={post.guests}
        video={post.fields.video_url}
        matterport={post.fields.matterport_url}
        contactInfo={post.fields.contact_info}
      />
      <EventContent event={post} />
      <ProviderEvents
        section={{
          events: post.fields.provider,
          title: 'Lisää samalta tarjoajalta',
          controls: true,
        }}
      />
      <FaqAndCTA
        section={{ faq: post.fields.faq, cta: post.fields.event_cta }}
      />
      <RelatedEvents
        section={{
          events: post.fields.related,
          title: 'Saattaisit pitää myös näistä',
        }}
      />
      <BackToSearch />
    </Layout>
  )
}
